module.exports = __webpack_public_path__ + "img/icon_invite-email.cbfb0ea8.svg";